const canvasAdCreative = (adPrototype, formParameters) => {
  const {
    asset_id: assetId,
    message: adMessage,
    title: adTitle,
    thumbnail,
    canvasUrl
  } = adPrototype;
  const { pageId } = formParameters;
  const adCreative = {
    object_story_spec: {
      page_id: pageId,
      video_data: {
        video_id: assetId,
        title: adTitle,
        message: adMessage,
        call_to_action: {
          type: 'LEARN_MORE',
          value: {
            link_caption: '',
            link: canvasUrl || ''
          }
        },
        image_url: thumbnail
      }
    },
    degrees_of_freedom_spec: {
      creative_features_spec: {
        standard_enhancements: {
          enroll_status: 'OPT_OUT'
        }
      }
    },
  };

  return adCreative;
};

const collectionAdCreative = (adPrototype, formParameters) => {
  const {
    asset_id: assetId,
    message: adMessage,
    title: adTitle,
    thumbnail,
    canvasUrl
  } = adPrototype;
  const { pageId } = formParameters;
  const adCreative = {
    product_set_id: '198689737505039', // static product set from Nikolai test for now
    object_story_spec: {
      page_id: pageId,
      video_data: {
        video_id: assetId,
        title: adTitle,
        message: adMessage,
        call_to_action: {
          type: 'LEARN_MORE',
          value: {
            link: canvasUrl || '',
            link_format: 'VIDEO_LPP'
          }
        },
        image_url: thumbnail,
        retailer_item_ids: ['0', '0', '0', '0']
      }
    },
    degrees_of_freedom_spec: {
      creative_features_spec: {
        standard_enhancements: {
          enroll_status: 'OPT_OUT'
        }
      }
    },
  };

  return adCreative;
};

const carouselAdCreative = (adPrototype, formParameters) => {
  const { message: adMessage, call_to_action: callToAction } = adPrototype;
  const { pageId } = formParameters;

  const cards = [];
  adPrototype.cards.forEach((card) => {
    const { thumbnail, headline, description, asset_id: assetId } = card;
    cards.push({
      link: 'https://constellationagency.com/',
      picture: thumbnail.includes('s3.amazonaws.com')
        ? thumbnail
        : encodeURIComponent(thumbnail),
      name: headline,
      description,
      call_to_action: {
        type: callToAction,
        value: { link: '' }
      },
      video_id: assetId
    });
  });

  const adCreative = {
    object_story_spec: {
      page_id: pageId,
      link_data: {
        link: 'https://constellationagency.com/',
        message: adMessage,
        caption: '',
        call_to_action: { type: callToAction },
        child_attachments: cards,
        multi_share_end_card: false,
        multi_share_optimized: false
      }
    },
    degrees_of_freedom_spec: {
      creative_features_spec: {
        standard_enhancements: {
          enroll_status: 'OPT_OUT'
        }
      }
    },
  };

  return adCreative;
};

const daaAdCreative = (adPrototype, formParameters) => {
  const {
    message: adMessage,
    title: adTitle,
    call_to_action: callToAction
  } = adPrototype;
  const { pageId } = formParameters;

  const adCreative = {
    object_story_spec: {
      page_id: pageId,
      template_data: {
        link: 'https://constellationagency.com/',
        message: adMessage,
        name: adTitle,
        description: '', // adPrototype.footer_text || adDescription,
        call_to_action: {
          type: callToAction
        },
        multi_share_end_card: true,
        format_option: 'carousel_images_multi_items'
      }
    },
    degrees_of_freedom_spec: {
      creative_features_spec: {
        standard_enhancements: {
          enroll_status: 'OPT_OUT'
        }
      }
    },
  };

  return adCreative;
};

const stillOrVideoAdCreative = (adPrototype, formParameters) => {
  const {
    thumbnail,
    message: adMessage,
    title: adTitle,
    footer_text: footerText,
    call_to_action: callToAction
  } = adPrototype;
  const { pageId } = formParameters;
  const adCreative = {
    object_story_spec: {
      page_id: pageId,
      link_data: {
        picture: thumbnail,
        link: 'https://constellationagency.com/',
        message: adMessage,
        name: adTitle,
        description: footerText,
        call_to_action: {
          type: callToAction
        }
      }
    },
    degrees_of_freedom_spec: {
      creative_features_spec: {
        standard_enhancements: {
          enroll_status: 'OPT_OUT'
        }
      }
    },
  };

  return adCreative;
};

export const returnAdCreative = (adType, adPrototype, formParameters) => {
  let adCreative = {};
  switch (adType) {
    case 'Canvas':
      adCreative = canvasAdCreative(adPrototype, formParameters);
      break;
    case 'Collection':
      adCreative = collectionAdCreative(adPrototype, formParameters);
      break;
    case 'Carousel':
      adCreative = carouselAdCreative(adPrototype, formParameters);
      break;
    case 'DAA':
      adCreative = daaAdCreative(adPrototype, formParameters);
      break;
    case 'Still':
      adCreative = stillOrVideoAdCreative(adPrototype, formParameters);
      break;
    case 'Cinemagraph':
    case 'Video':
      adCreative = stillOrVideoAdCreative(adPrototype, formParameters);
      break;
    default:
      break;
  }
  return adCreative;
};



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdBuilderAdPreviewCreative.js